import { Text } from "@chakra-ui/react";
import React from "react";

function CustomText({
  family,
  size,
  weight,
  color,
  cursor,
  text,
  onClick,
  height,
  decoration,
  align,
}: any) {
  return (
    <Text
      // style={{ fontFamily: "Bryndan Write" }}
      // fontFamily={family || "Bryndan Write"}
      fontSize={size || "16px"}
      fontWeight={weight || "normal"}
      color={color || "black"}
      cursor={cursor || "default"}
      userSelect={cursor ? "none" : "auto"}
      onClick={onClick}
      lineHeight={height || "normal"}
      textDecoration={decoration || "none"}
      textAlign={align || "left"}
    >
      {text}
    </Text>
  );
}

export default CustomText;
